// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.digital-stamp-main-view {
	background-color: #ecf0e5;
	padding: 16px;
	margin-bottom: 16px;
}
.stamp-row-direction {
	display: flex;
	flex-direction: row;
}
.margin-bottom {
	margin-bottom: 16px;
}
.margin-bottom-top {
	margin-bottom: 16px;
	margin-top: 16px;
}
.stamp-remove-button {
	justify-content: flex-end;
	display: flex;
	cursor: pointer;
}
.stamp-field-space-between {
	width: 100%;
	display: flex;
	flex-direction: row;
	margin-bottom: 16px;
	justify-content: space-between;
}
.stamp-scroll-height {
	height: 700px;
	overflow-y: scroll;
	overflow-x: hidden;
	padding: 3px;
}
.stamp-dotted-border {
	border-style: dashed;
	border-width: 1px;
	border-color: #8e8e8e;
	margin: 24px 0px;
}
.stamp-test-space {
	justify-content: space-between;
	display: flex;
}
.text-transform-capitalise {
	text-transform: capitalize !important;
}
.stamp-scroll-height::-webkit-scrollbar {
	width: 3px;
}
.toast-message {
	margin-bottom: 0rem;
}
.text-wrap {
	white-space: nowrap;
}
.loader-style {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	opacity: 0.5;
	z-index: 999;
	height: 100%;
	overflow: hidden;
}
.qty-left-space {
	margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/DigitalStampOrderPopup/digital-stamp-popup.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,aAAa;CACb,eAAe;AAChB;AACA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,8BAA8B;AAC/B;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,oBAAoB;CACpB,iBAAiB;CACjB,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,8BAA8B;CAC9B,aAAa;AACd;AACA;CACC,qCAAqC;AACtC;AACA;CACC,UAAU;AACX;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB","sourcesContent":[".digital-stamp-main-view {\n\tbackground-color: #ecf0e5;\n\tpadding: 16px;\n\tmargin-bottom: 16px;\n}\n.stamp-row-direction {\n\tdisplay: flex;\n\tflex-direction: row;\n}\n.margin-bottom {\n\tmargin-bottom: 16px;\n}\n.margin-bottom-top {\n\tmargin-bottom: 16px;\n\tmargin-top: 16px;\n}\n.stamp-remove-button {\n\tjustify-content: flex-end;\n\tdisplay: flex;\n\tcursor: pointer;\n}\n.stamp-field-space-between {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin-bottom: 16px;\n\tjustify-content: space-between;\n}\n.stamp-scroll-height {\n\theight: 700px;\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n\tpadding: 3px;\n}\n.stamp-dotted-border {\n\tborder-style: dashed;\n\tborder-width: 1px;\n\tborder-color: #8e8e8e;\n\tmargin: 24px 0px;\n}\n.stamp-test-space {\n\tjustify-content: space-between;\n\tdisplay: flex;\n}\n.text-transform-capitalise {\n\ttext-transform: capitalize !important;\n}\n.stamp-scroll-height::-webkit-scrollbar {\n\twidth: 3px;\n}\n.toast-message {\n\tmargin-bottom: 0rem;\n}\n.text-wrap {\n\twhite-space: nowrap;\n}\n.loader-style {\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\topacity: 0.5;\n\tz-index: 999;\n\theight: 100%;\n\toverflow: hidden;\n}\n.qty-left-space {\n\tmargin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
